import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Svg from '@eversports/klimt-primitives/legacy/Svg'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import NewBadge from '../../../../components/NewBadge'
import {
  useActivityDetailsGetAssignedSpotDeprecatedQuery,
  useActivityDetailsGetAssignedSpotQuery,
} from '../../../../graphql'
import { Localized } from '../../../../localization/react'
import { paramToEventTypeMapping } from '../../ActivityDetails.constants'

import Spot from './assets/spot.svg'
import { SPOT_BOOKING_FROM } from './SpotBooking.constants'

interface Props {
  goToPreviewSpot: string
}
const SpotBooking = ({ goToPreviewSpot }: Props) => {
  const { activityId, shortId, eventType } = useParams<{ eventType?: string; shortId?: string; activityId?: string }>()

  const { data, loading, refetch } = activityId
    ? useActivityDetailsGetAssignedSpotQuery({
        variables: { id: activityId },
      })
    : // we keep the old URL structure for some time until we replaced all the URL referencing this page
      shortId && eventType
      ? useActivityDetailsGetAssignedSpotDeprecatedQuery({
          variables: { eventType: paramToEventTypeMapping[eventType], shortId },
        })
      : (undefined as never)

  const assignedSpot = data?.getEventBookableItem.assignedSpot

  // When someone changes the spot, and goes back to the page, we want to show correct spot
  useEffect(() => {
    void refetch()
  }, [refetch])

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" columnGap={2} rowGap={1}>
      <Svg src={Spot} width={12} height={12} />
      <Text color="midnight" sx={{ fontWeight: 'bold' }}>
        <Localized id="activity-detail-spot-booking-title" />
      </Text>
      <NewBadge variant="primary" />
      <Text variant="small" sx={{ flexBasis: '100%', textDecoration: 'underline' }}>
        {assignedSpot?.spot && !loading ? (
          <Link
            to={`/user/bookings/${assignedSpot.appointmentParticipationId}/spots?from=${SPOT_BOOKING_FROM.ACTIVITY_DETAIL}`}
            external
          >
            <Localized id="activity-detail-your-spot" />: {assignedSpot.spot.label}
          </Link>
        ) : (
          <Link to={goToPreviewSpot} external>
            <Localized id="activity-detail-spot-booking-preview" />
          </Link>
        )}
      </Text>
    </Stack>
  )
}

export { SpotBooking }
